import React from 'react'

import { Field } from 'formik'

import { Button, Form, Col } from '_zari/core'

import { MonedasConstant } from 'constants/index'

import { TipoCambioModal } from 'sharedComponents/modals'

import { KeyEventUtil } from 'utils'

import * as TiposCambioService from 'services/tiposCambio.service'

const TipoCambioFormGroup = ({ iError, iTouched, iMoneda, iFechaDocumento, setFieldValue }) => {
  const [mostrarModal, setMostrarModal] = React.useState(false)

  const consultarTipoCambio = React.useCallback(() => {
    const monedaConsulta =
      iMoneda === MonedasConstant.EUROS ? MonedasConstant.EUROS : MonedasConstant.DOLARES

    TiposCambioService.getxFechaxMonedaxTipoCambio(iFechaDocumento, monedaConsulta, 'VENT').then(
      ({ data }) => {
        setFieldValue('tipoCambio', data.tipoCambio || 0)
      }
    )
  }, [iMoneda, iFechaDocumento, setFieldValue])

  React.useEffect(() => {
    if (iFechaDocumento !== '' && iMoneda !== '') {
      consultarTipoCambio()
    } else {
      setFieldValue('tipoCambio', 0)
    }
  }, [iFechaDocumento, iMoneda, consultarTipoCambio, setFieldValue])

  const clickTiposCambio = React.useCallback(() => {
    setMostrarModal(true)
  }, [])

  const handleCloseModal = React.useCallback(() => {
    setMostrarModal(false)
    consultarTipoCambio()
  }, [consultarTipoCambio])

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-tipoDocumento', e)
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='T/C' htmlFor='input-tipoCambio' md={4} alignRightAt='md' />
        <Col md={8}>
          <Form.InputGroup>
            <Field name='tipoCambio'>
              {({ field }) => (
                <Form.InputNumber
                  {...field}
                  id='input-tipoCambio'
                  disabled
                  isInvalid={iTouched && iError}
                  onKeyDown={onKeyDown}
                />
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={clickTiposCambio}>O</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarModal && (
        <TipoCambioModal
          show={mostrarModal}
          handleClose={handleCloseModal}
          fechaReferencia={iFechaDocumento}
        />
      )}
    </>
  )
}

export default React.memo(TipoCambioFormGroup)
